<ng-template #voorwaarden>
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <!-- prettier-ignore -->
        <span>
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsCaravanInsurance"
                      pdfLinkTitle="Voorwaarden Caravanverzekering">in onze voorwaarden</ins-pdf-link>.</span>
    </p>
</ng-template>

<ng-container *ngIf="coverageId === coverageIdEnum.CaravanInboedel">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <p>Schade aan spullen in uw caravan door:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Een ongeval bij het rijden</list-flat-item>
                <list-flat-item>Brand, ontploffing of kortsluiting</list-flat-item>
                <list-flat-item>Storm of blikseminslag</list-flat-item>
                <list-flat-item>Overstroming</list-flat-item>
                <list-flat-item>Aardbeving of lawines</list-flat-item>
                <list-flat-item>
                    Vermissing, (poging tot) diefstal of inbraak. Er moet sprake zijn van braak
                </list-flat-item>
                <list-flat-item>Botsing met dieren</list-flat-item>
            </list-flat>
            <p>
                Onder inboedel verstaan wij de duurzame, huishoudelijke spullen. Deze horen niet standaard bij uw
                caravan. Maar worden wel binnen of bij de caravan gebruikt. Denk aan bedden- en linnengoed,
                audioapparatuur, lampen, verwarming, toilet, keukenspullen en meubilair.
            </p>
            <p>Verzekerd is:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Maximaal €&nbsp;4.000</list-flat-item>
                <list-flat-item>Waarvan max. €&nbsp;750 voor audioapparatuur</list-flat-item>
                <list-flat-item>Max. €&nbsp;500 bij diefstal uit voortent of aanbouw</list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <p>Schade aan uw spullen door:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Verkleuringen, krassen en slijtage</list-flat-item>
                <list-flat-item>Normaal (huishoudelijk) gebruik, herstellen of reinigen</list-flat-item>
                <list-flat-item>Onvoldoende of verkeerd onderhoud</list-flat-item>
                <list-flat-item>Zonlicht, bevriezing, warmte, kou of vocht, sneeuw of sneeuwdruk</list-flat-item>
                <list-flat-item>
                    Vermissing, diefstal of inbraak als uw caravan niet is beveiligd met een VbV/SCM goedgekeurd
                    disselslot of wielklem.
                </list-flat-item>
                <list-flat-item>Diefstal zonder braak</list-flat-item>
            </list-flat>
            <p>Hagelschade is niet standaard verzekerd, maar wel aanvullend te verzekeren met onze Hageldekking.</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;125</p>
            <p>
                Let op: Heeft u geen Europadekking bij uw caravanverzekering afgesloten en krijgt u schade buiten de
                Benelux en Duitsland? Dan is uw eigen risico: €&nbsp;1.500.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.CaravanExtra">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <p>Schade aan extra’s door:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Brand, ontploffing of kortsluiting</list-flat-item>
                <list-flat-item>Storm of blikseminslag</list-flat-item>
                <list-flat-item>Overstroming</list-flat-item>
                <list-flat-item>Aardbeving of lawines</list-flat-item>
                <list-flat-item>
                    Vermissing, (poging tot) diefstal of inbraak. Er moet sprake zijn van braak
                </list-flat-item>
                <list-flat-item>Botsing met dieren</list-flat-item>
            </list-flat>
            <p>
                Onder extra’s verstaan wij spullen die bij uw caravan horen of die u bij uw caravan gebruikt. Denk aan
                een voortent, luifel, mover, antenne en satellietschotel of fietsdrager.
            </p>
            <p>Verzekerd is maximaal €&nbsp;4.000</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <p>Schade aan uw extra’s:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Door verkleuringen, krassen en slijtage</list-flat-item>
                <list-flat-item>Als uw voortent buiten staat van 1 december tot 1 maart</list-flat-item>
                <list-flat-item>Door onvoldoende of verkeerd onderhoud</list-flat-item>
                <list-flat-item>Door zonlicht, bevriezing, warmte, kou of vocht, sneeuw of sneeuwdruk</list-flat-item>
                <list-flat-item>
                    Door vermissing, diefstal of inbraak als uw caravan niet is beveiligd met een VbV/SCM goedgekeurd
                    disselslot of wielklem. Door hagel (tenzij u dit extra heeft meeverzekerd).
                </list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;125</p>
            <p>
                Let op: Heeft u geen Europadekking bij uw caravanverzekering afgesloten en krijgt u schade buiten de
                Benelux en Duitsland? Dan is uw eigen risico: €&nbsp;1.500.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.CaravanHagelEU || coverageId === coverageIdEnum.CaravanHagelNL">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <p>Schade door hagel:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Aan uw caravan</list-flat-item>
                <list-flat-item>Aan uw inboedel als u deze heeft meeverzekerd</list-flat-item>
                <list-flat-item>
                    Aan uw extra’s (zoals voortent, luifel, antenne of schotel) als u deze heeft meeverzekerd
                </list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <p>Schade door hagel:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>
                    Als u met uw caravan gaat rijden en er is gewaarschuwd voor storm of zwaar weer met kans op hagel of
                    bliksem
                </list-flat-item>
                <list-flat-item>
                    In de periode van 1 december tot 1 maart als uw voortent beschadigd raakt door hagel
                </list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;125</p>
            <p>
                Let op: Heeft u geen Europadekking bij uw caravanverzekering afgesloten en krijgt u schade buiten de
                Benelux en Duitsland? Dan is uw eigen risico: €&nbsp;1.500.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>
